import { Entity, Field } from "typegraph";


@Entity({    
    update: "course_bookmark"
})
export default class CourseBookmark {

    @Field()
    public entityId: number;
}


// WEBPACK FOOTER //
// ./src/panels/catalog/entities/CourseBookmark.ts